import { removeDuplicateFragments } from './removeDuplicateFragments';

export const gql = (
  chunks: TemplateStringsArray,
  ...variables: unknown[]
): string => {
  const query = String.raw({ raw: chunks }, ...variables);
  return removeDuplicateFragments(query);
};
